export default {

    data() {

        return {
            colors: [
                {id: 1, checked: true, rgba: 'rgba(160, 41, 87, 1)'},
                {id: 2, checked: false, rgba: 'rgba(227, 93, 51, 1)'},
                {id: 3, checked: false, rgba: 'rgba(223, 196, 90, 1)'},
                {id: 4, checked: false, rgba: 'rgba(55, 125, 73, 1)'},
                {id: 5, checked: false, rgba: 'rgba(65, 83, 175, 1)'},
                {id: 6, checked: false, rgba: 'rgba(131, 50, 164, 1)'},
                {id: 7, checked: false, rgba: 'rgba(200, 52, 97, 1)'},
                {id: 8, checked: false, rgba: 'rgba(224, 115, 44, 1)'},
                {id: 9, checked: false, rgba: 'rgba(194, 200, 81, 1)'},
                {id: 10, checked: false, rgba: 'rgba(63, 147, 136, 1)'},
                {id: 11, checked: false, rgba: 'rgba(123, 135, 198, 1)'},
                {id: 12, checked: false, rgba: 'rgba(116, 86, 74, 1)'},
                {id: 13, checked: false, rgba: 'rgba(197, 41, 28, 1)'},
                {id: 14, checked: false, rgba: 'rgba(228, 150, 53, 1)'},
                {id: 15, checked: false, rgba: 'rgba(135, 176, 83, 1)'},
                {id: 16, checked: false, rgba: 'rgba(65, 154, 223, 1)'},
                {id: 17, checked: false, rgba: 'rgba(175, 159, 215, 1)'},
                {id: 18, checked: false, rgba: 'rgba(97, 97, 97, 1)'},
                {id: 19, checked: false, rgba: 'rgba(217, 129, 119, 1)'},
                {id: 20, checked: false, rgba: 'rgba(238, 192, 75, 1)'},
                {id: 21, checked: false, rgba: 'rgba(91, 179, 126, 1)'},
                {id: 22, checked: false, rgba: 'rgba(65, 115, 222, 1)'},
                {id: 23, checked: false, rgba: 'rgba(151, 109, 171, 1)'},
                {id: 24, checked: false, rgba: 'rgba(155,147,155, 1)'},
            ],
        }
    },

    methods: {
        getNameOfAvatar(photo) {
            return `url('/uploads/${photo}')`
        },
        getRGBAColor(colorId) {
            const colorMap = {
                1: 'rgba(160, 41, 87, 1)',
                2: 'rgba(227, 93, 51, 1)',
                3: 'rgba(223, 196, 90, 1)',
                4: 'rgba(55, 125, 73, 1)',
                5: 'rgba(65, 83, 175, 1)',
                6: 'rgba(131, 50, 164, 1)',
                7: 'rgba(200, 52, 97, 1)',
                8: 'rgba(224, 115, 44, 1)',
                9: 'rgba(194, 200, 81, 1)',
                10: 'rgba(63, 147, 136, 1)',
                11: 'rgba(123, 135, 198, 1)',
                12: 'rgba(116, 86, 74, 1)',
                13: 'rgba(197, 41, 28, 1)',
                14: 'rgba(228, 150, 53, 1)',
                15: 'rgba(135, 176, 83, 1)',
                16: 'rgba(65, 154, 223, 1)',
                17: 'rgba(175, 159, 215, 1)',
                18: 'rgba(97, 97, 97, 1)',
                19: 'rgba(217, 129, 119, 1)',
                20: 'rgba(238, 192, 75, 1)',
                21: 'rgba(91, 179, 126, 1)',
                22: 'rgba(65, 115, 222, 1)',
                23: 'rgba(151, 109, 171, 1)',
                24: 'rgb(155,147,155,1)',
            };
            return colorMap[colorId] || '';
        },
        getPriorityClass(priority) {
            const priorityClasses = {
                'low': 'color--green',
                'medium': 'color--orange',
                'high': 'color--red'
            };
            return `mb-3 ${priorityClasses[priority] || ''}`;
        },
        showColorPriority(status) {
            const statusColors = {
                'low': 'color--green',
                'medium': 'color--orange',
                'high': 'color--red'
            };
            return statusColors[status] || '';
        },
        truncatedString(comment) {
            if (comment.length > 20) {
                return comment.slice(0, 20) + '...';
            } else {
                return comment;
            }
        },
        statusLogo(status) {
            if (status === 'active') {
                return "/img/svg/green.svg"
            } else if (status === 'pending') {
                return "/img/svg/orange.svg"
            } else {
                return "/img/svg/blue.svg"
            }
        },
        selectColor(item) {
            switch (item) {
                case 'approved':
                    return '#60ad45';
                case 'new':
                    return '#333333';
                case 'needs-attention':
                    return '#dd3722';
                default:
                    return '#0a0a68';
            }
        },
        stripTags(string) {
            return string.replace(/<\/?[^>]+(>|$)/g, "");
        },
        applicantTopBlockClasses(status) {
            const statusClasses = {
                'active': 'active',
                'pending': 'pending',
                'inactive': 'inactive'
            };

            return ['applicant-full-top-block', `applicant-full-top-block-${statusClasses[status]}`];
        },
    }
}
